module.exports = __webpack_public_path__ + "img/chongzhou5.18f1a002.png";